<template>
    <bottom-dialog v-model="showDialog" :dialog="true" max-width="550px">
        <v-card flat tile>
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                {{$translate(add ? 'Search player' : 'Edit the post')}}
                <v-spacer />
                <v-btn icon @click="showDialog = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="mt-4">
                <FormField :field="commentField" v-model="changed.comment" />

                <v-row v-if="add">
                    <v-col cols="12">
                        <FormField :field="teamField" v-model="changed.group_id" />
                    </v-col>
                </v-row>

            </v-card-text>

            <v-card-actions>
                <v-btn v-if="!add" color="error" @click="removePost">{{$translate('Remove post')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :loading="saving" :disabled="!canSave">{{$translate('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue';
import FormField from '../components/FormField.vue';
export default {
    name: 'zoezi-teamsport-player-pool-team-post-dialog',
    props: {
        value: {
            type: Boolean
        },
        add: {
            type: Boolean
        },
        post: {
            type: Object
        },
        groups: {
            type: Array
        }
    },

    components: {
        BottomDialog,
        FormField
    },

    watch: {
        value: {
            immediate: true,
            handler(show) {
                if (show) {
                    if (this.add) {
                        this.changed.comment = null;
                        this.changed.group_id = null;
                    } else {
                        this.changed.comment = this.post.comment;
                        this.changed.group_id = this.post.group.id;
                    }
                }
            }
        }
    },

    data: () => ({
        changed: {
            comment: null,
            group_id: null
        },
        saving: false
    }),

    computed: {
        showDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        commentField() {
            return {
                type: 'textarea',
                title: 'Description of wanted players',
                placeholder: 'We are looking for you who...'
            }
        },
        teamField() {
            return {
                type: 'select',
                title: 'For team',
                placeholder: 'Choose team',
                data: this.groups?.map(group => {
                    return {
                        text: group.name,
                        value: group.id
                    }
                })
            }
        },
        canSave() {
            if (this.add) {
                return this.changed.comment && this.changed.group_id;
            } else {
                return this.changed.comment;
            }
        }
    },
    methods: {
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        },
        save() {
            if (this.add) {
                const data = {
                    comment: this.changed.comment,
                    group_id: this.changed.group_id
                }
                this.saving = true;
                this.$api.post('/api/playerpoolteam/add', data).then(response => {
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.saving = false;
                    this.possiblyShowError(response)
                });
            } else {
                const data = {
                    comment: this.changed.comment,
                    group_id: this.changed.group_id,
                    id: this.post.id
                }
                this.saving = true;
                this.$api.post('/api/playerpoolteam/change', data).then(response => {
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.saving = false;
                    this.possiblyShowError(response)
                });
            }
        },
        removePost() {
            this.$store.commit('showConfirmDialog', {
                title: this.$translate('Remove post'),
                text: this.$translate('Are you sure you want to remove the post?'),
                actionText: this.$translate('Remove'),
                action: () => {
                    this.$api.post('/api/playerpoolteam/remove', null, {id: this.post.id}).then(response => {
                        if (response.ok) {
                            this.showDialog = false
                        }
                        this.possiblyShowError(response)
                    });
                }
            });
        }
    }
}
</script>
